import React, { memo } from "react";
import { Typography } from "@material-ui/core";
import Select from "react-select";

function MonthYearsSelect(props) {
  const { onChange, value, monthYearsArray } = props;

  return (
    <div className="mb-24">
      <Select
        className="full-width"
        onChange={({ value }) => {
          onChange(value);
        }}
        options={monthYearsArray}
        value={value}
      />
    </div>
  );
}

export default memo(MonthYearsSelect);
